@if (profileField$ | async; as profileField) {
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" [style]="nestedPadding$ | async">
        <sh-field-label [label]="profileField.DisplayLabel"></sh-field-label>
    </dt>
    <dd class="sh-description-list__details">
        @if (faces.length === 0) {
            -
        }
    </dd>
    @for (face of faces; track face.Id; let recordIndex = $index) {
        <dl class="sh-description-list sh-clear-margin" style="flex-flow: row; width: 100%">
            <dt
                class="sh-description-list__term"
                style="height: 2.5rem"
                [ngStyle]="nestedPadding$ | async"
                (mouseenter)="hoverFaceFrame(face)"
                (mouseleave)="unhoverFaceFrame()"
            >
                <i>{{ childDefinitionLabel$ | async }} {{ recordIndex + 1 }}</i>
                @if (face.Person?.AiLinked) {
                    <div [title]="'profile-form.ai-generated-value' | translate" style="display: inline-block; margin-left: 0.25rem">
                        <svg sh-icon [size]="'small'" [name]="'magic'" style="margin-bottom: 0.2rem"></svg>
                    </div>
                }
            </dt>
            <dd class="sh-description-list__details" style="height: 2.5rem">
                @if (personIdFieldDefinition && personIdSearchable && face.Person && $any(face.Person).RecordId) {
                    <ul class="sh-tag-list">
                        <a
                            class="sh-tag--link sh-tag-list__item"
                            tabindex="0"
                            [title]="$any(face.Person).Name"
                            [id]="face.Id + '-0'"
                            [routerLink]="searchRouterLink"
                            [queryParams]="getSearchRouterParams(personIdFieldDefinition, $any(face.Person).RecordId)"
                            (mouseenter)="hoverFaceFrame(face)"
                            (mouseleave)="unhoverFaceFrame()"
                        >
                            <span
                                class="sh-tag__label"
                                >{{ $any(face.Person).Name }}</span
                            >
                        </a>
                    </ul>
                } @else {
                    <sh-face-tag style="height: 100%; display: flex; align-items: center" [face]="face"></sh-face-tag>
                }
            </dd>
        </dl>
    }

    <dt class="sh-description-list__term"></dt>
    <dd class="sh-description-list__details sh-complex-spacer"></dd>
}
